// 1 - 25
export const systemAgeOptions = new Array(25)
	.fill(0)
	.map((_, i) => (i + 1).toString());

// 100 - 5000 at increments of 100
export const repairCostOptions = new Array(50)
	.fill(0)
	.map((_, i) => (i + 1) * 100)
	.map((cost) => cost.toString());
